module.exports = __webpack_public_path__ + "static/media/decreto kwong 2 50.90d79d65.jpg";